// controllers/hoverable_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["row"]

  connect() {
    // on garde une référence pour pouvoir la retirer proprement
    this._resetHandler = this.reset.bind(this)
    document.addEventListener("click", this._resetHandler)
  }

  disconnect() {
    document.removeEventListener("click", this._resetHandler)
  }

  select(event) {
    event.stopPropagation()

    // désactiver toutes les lignes
    this.rowTargets.forEach(r => r.classList.remove("active"))

    // activer la ligne cliquée
    event.currentTarget.classList.add("active")
  }

  reset(event) {
    if (!this.element.contains(event.target)) {
      this.rowTargets.forEach(r => r.classList.remove("active"))
    }
  }
}
